var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('h5',{staticClass:"grey--text text--darken-4 ml-2"},[_c('v-icon',{staticClass:"mr-1 teal--text",attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }